import type { RouteObject } from 'react-router';

import { NotFoundPage } from './NotFound';

/**
 * The named not-found route. One `RouteObject`, so the file is `.route.tsx`
 * singular.
 *
 * It sits in the **unguarded** shell layout. The guard chain answers a missing
 * session with `/login?next=…`, which is the right answer for a surface that
 * exists; it is the wrong answer for a URL that names none, because it would
 * send an operator to sign in for a page that will not be there afterwards
 * either. Nothing on this page reads a gated endpoint, so there is nothing for a
 * guard to protect.
 *
 * The unmatched-path catch-all is declared beside it in `system.routes.tsx` and
 * renders this same surface **at the URL that failed**, rather than redirecting
 * to this one and losing the address the operator was reading.
 */
export const notFoundRoute: RouteObject = {
  path: '/404',
  element: <NotFoundPage />,
};
